<style>
    .wrapperx {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
    }

    .m-form .m-form__group:first-child {
        padding-top: 15px;
    }

</style>

<template>
    <form method="POST" class="m-form m-form--state" id="myForm" v-on:submit.prevent="save">
        <div class="row m-portlet__body">
            <div class="col-md-12">
                <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('name')}">
                    <label>
                        {{$t('Name')}}
                    </label>
                    <input type="text" class="form-control m-input" v-model="model.name">
                    <div class="form-control-feedback">
                        <span v-for="message in filter('name')" v-bind:key="message">
                            {{message}} <br/>
                        </span>
                    </div>
                </div>
                <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('lead')}">
                    <label>
                        {{$t('Lead')}}
                    </label>
                    <textarea class="form-control" v-model="model.lead" :id="`editor2`"></textarea>
                    <div class="form-control-feedback">
                            <span v-for="message in filter('lead')" v-bind:key="message">
                                {{message}} <br/>
                            </span>
                    </div>
                </div>
                <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('description')}">
                    <label>
                        {{$t('Leírás')}}
                    </label>
                    <textarea class="form-control" v-model="model.description" :id="`editor1`"></textarea>
                    <div class="form-control-feedback">
                            <span v-for="message in filter('description')" v-bind:key="message">
                                {{message}} <br/>
                            </span>
                    </div>
                </div>
                <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('image')}">
                    <label>
                        {{$t('Szerző kép')}}
                    </label>
                    <input type="file" accept="image/*" class="form-control m-input" ref="file1" id="file1" name="image" v-on:change="setImage($event)" />
                    <!--<input type="file" accept="image/*" class="form-control m-input" id="file1" ref="file1" name="uploadFile1" @change="handleUpload('file1')" />-->
                    <div v-if="file != null" style="width: 100%; height:auto; min-height: 400px;">
                      <vue-cropper
                        ref='cropper'
                        :guides="false"
                        :view-mode="2"
                        drag-mode="crop"
                        :aspect-ratio="1"
                        :auto-crop-area="0.5"
                        :min-container-width="250"
                        :min-container-height="180"
                        :src="imgSrc"
                        :ready="cropImage"
                        :cropend="cropImage"
                        :zoomable="false"
                        alt="Kép"
                        :img-style="{ 'width': '100%', 'height': 'auto' }">
                      </vue-cropper>
                    </div>
                    <img class="img-fluid" v-if="model.image_url !== null" :src="model.image_url" style="display: inline-block; max-width: 300px; height: auto;" />
                    <div class="form-control-feedback">
                            <span v-for="message in filter('image')" v-bind:key="message">
                                {{message}} <br/>
                            </span>
                    </div>
                </div>
            </div>
        </div>
        <Buttons v-on:save="save" :list-link="`/admin/authors/index`"></Buttons>
    </form>
</template>

<script>
import VueCropper from 'vue-cropperjs'
import Buttons from '../../core/form/Buttons'
export default {
  name: 'AuthorForm',
  components: {vueCropper: VueCropper, Buttons},
  props: {
    model: {
      type: Object,
      required: true
    },
    errors: {
      type: Object
    },
    url: {
      require: true
    }
  },
  data () {
    return {
      file: null,
      image: null,
      imgSrc: '',
      cropImg: ''
    }
  },
  watch: {
    model: {
      handler (val) {
        this.$store.commit('loading/changeUnsaved', true)
        if (val && val.url !== undefined) {
          this.model.url = this.model.url.toLowerCase()
          if (val.url.startsWith('/') === false) {
            this.model.url = '/' + this.model.url.toLowerCase()
          }
        }
      },
      deep: true
    }
  },
  methods: {
    hasError (val) {
      for (let er in this.errors) {
        if (er === val) {
          return true
        }
      }

      return false
    },
    save () {
      if (this.imgSrc === '') {
        this.$store.commit('loading/changeUnsaved', false)
        this.$emit('save')
      } else {
        this.$http
          .post(process.env.API_URL + '/api/v1/admin/settings/upload-base64', {image: this.model.picUrl}, {
            'headers': {
              'Authorization': 'Bearer ' + localStorage.getItem('token'),
              'language': this.$store.state.loading.language
            }
          }).then(res => {
            this.model.image = res.data.data.path
            this.model.image_url = res.data.data.uri
            this.file = null
            window.$('#file').val(null)
            this.$store.commit('loading/changeUnsaved', false)
            this.$emit('save')
          }).catch(res => {
          })
      }
    },
    filter: function (name) {
      for (let er in this.errors) {
        if (er === name) {
          this.hasDanger = true
          return this.errors[er]
        }
      }

      this.hasDanger = false
      return ''
    },
    setImage (event) {
      this.file = event.target.files[0]
      if (!this.file.type.includes('image/')) {
        alert('Please select an image file')
        return
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader()

        reader.onload = (event) => {
          this.imgSrc = event.target.result
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result)
        }

        reader.readAsDataURL(this.file)
      } else {
        alert('Sorry, FileReader API not supported')
      }
    },
    cropImage () {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
      let cropImgUrl = "url('" + this.cropImg + "')"
      this.model.picUrl = cropImgUrl
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/author/AuthorForm.vue